import React, { useState } from "react";
import CartService from "../../../../service/CartService";
import useFormContext from "../../../../common/hooks/useFormContext";
import { useCart } from "../../../../utils/CartHooks";
import SelectableBox from "../../../../common/components/Box/SelectableBox";
import TwoLeavesIcon from "../../../../common/components/Icon/TwoLeavesIcon";
import { Typography } from "@mui/material";
import { palette } from "../../../../styles/theme";
import { Box, FlexColBox } from "../../../../common/components";
import ThreeLeavesIcon from "../../../../common/components/Icon/ThreeLeavesIcon";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "../../../../common/hooks/useSelector";
import { useCurrency } from "../../../../common/hooks/useCurrency";
import { CheckoutForm } from "../../Cart";
import CarbonNeutralModal from "../../../../components/CarbonNeutralModal/CarbonNeutralModal";

const CartCabonNeutral = () => {
  //disable the feature for now, its not ready
  return null;
  // eslint-disable-next-line no-unreachable
  const { formik } = useFormContext();
  const [openCarbonNeutralModal, setOpenCarbonNeutralModal] = useState(false);
  const { t } = useTranslation();
  const { carbonNeutral } = formik?.values as CheckoutForm;
  const { fetchCartItemsAndUpdateStore } = useCart();
  const { NarrowCurrencyFormatter } = useCurrency();
  const { cart } = useSelector((state) => state.cart);

  const handleCarbonNeutralClick = (value: boolean) => async () => {
    await CartService.updateCarbonNeutral(value);
    formik?.setFieldValue("carbonNeutral", value);
    fetchCartItemsAndUpdateStore();
  };
  // eslint-disable-next-line no-unreachable
  return (
    <FlexColBox gap={"12px"}>
      <Typography variant="textRegular" color={palette.grey.primary}>
        <Trans
          i18nKey="checkout.carbon_neutral.title"
          components={[
            <Typography variant="textSm" color={palette.grey.primary} />,
            <Typography
              variant="textSm"
              color={palette.grey.primary}
              onClick={(e) => {
                e.preventDefault();
                setOpenCarbonNeutralModal(true);
              }}
              sx={{
                color: palette.blue.secondary,
                cursor: "pointer",
                "&:hover": { textDecoration: "underline" },
              }}
            />,
            <Typography variant="textSm" color={palette.grey.primary} />,
          ]}
        />
      </Typography>
      <Box display="flex" gap={"12px"}>
        <SelectableBox
          onClick={handleCarbonNeutralClick(true)}
          startIcon={<ThreeLeavesIcon />}
          text={
            <Trans
              i18nKey="checkout.carbon_neutral.yes_please"
              values={{
                price: NarrowCurrencyFormatter?.format(
                  cart.carbonNeutralityFeeTotal || 0
                ),
              }}
              components={[
                <Typography
                  variant="textXs"
                  color={palette.misc.successText}
                />,
              ]}
            />
          }
          active={carbonNeutral}
        />
        <SelectableBox
          onClick={handleCarbonNeutralClick(false)}
          startIcon={<TwoLeavesIcon />}
          text={t("checkout.carbon_neutral.no_thanks")}
          active={!carbonNeutral}
        />
      </Box>
      <CarbonNeutralModal
        open={openCarbonNeutralModal}
        onClose={() => setOpenCarbonNeutralModal(false)}
      />
    </FlexColBox>
  );
};

export default CartCabonNeutral;
